import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class ShippingReceiveDepartmentService extends SingleDepartmentService {
  protected readonly router = inject(Router);
  readonly NAME = 'Shipping and Receive';

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('ShippingReceiveAdmin') ||
      roles.includes('ShippingReceiveChief') ||
      roles.includes('ShippingReceiveViewer') ||
      roles.includes('ShippingReceiveSupervisor') ||
      roles.includes('ShippingReceiveLeader')
    ) {
      this.router.navigate(['/sb/shipping-receive/register/purchase-order']);
      return true;
    } else if (
      roles.includes('ShippingReceiveTruckUser') ||
      roles.includes('ShippingReceiveTruckAdmin') ||
      roles.includes('ShippingReceiveViewer')
    ) {
      this.router.navigate(['/sb/shipping-receive/box/tracing']);
      return true;
    }
    return false;
  }
}
